import React, { useContext } from 'react';
import { AxiosError } from 'axios';
import { PageTitle } from './PageLayout/PageTitle';
import { PageContent } from './PageLayout/PageContent';
import { AuthContext } from '../models/AuthContext';

export interface IErrorPageProps {
    error: Error;
}

export const ErrorPage: React.FC<IErrorPageProps> = (
    props: IErrorPageProps
) => {
    const { authContext } = useContext(AuthContext);
    var message = props.error.message;

    // Show nicer message if we have details about the HTTP response
    const status = (props.error as AxiosError).response?.status;
    switch (status) {
        case 401:
            if (authContext.login) {
                authContext.login();
            } else {
                message = 'The provided access token could not be validated.';
            }
            break;
        case 403:
            message = 'You are not authorized to view this data.';
            break;
        default:
            message = "We can't seem to find what you're looking for.";
            break;
    }

    const showDeploymentNote =
        status === undefined || (status !== 401 && status !== 403);

    return (
        <div className="ErrorPage-root">
            <PageTitle title="Something went wrong" />

            <PageContent>
                {message}
                {showDeploymentNote && (
                    <p style={{ marginTop: '1em' }}>
                        If you recently deployed a release, there may be a delay
                        before it appears on this site. Heavy traffic can affect
                        processing times. Please wait a moment and try again.
                    </p>
                )}
            </PageContent>
        </div>
    );
};
